import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './assets/img/logo.png';

const _withScopeId = n => (_pushScopeId("data-v-e2e691ac"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "d-flex flex-wrap justify-content-center py-3 mb-4"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  height: "70"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fs-4 mx-2"
}, "1.5资料站", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow-1"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("道具搜索");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("怪物搜索");

export function render(_ctx, _cache) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_header = _resolveComponent("el-header");

  const _component_router_view = _resolveComponent("router-view");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_backtop = _resolveComponent("el-backtop");

  const _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      height: "auto",
      class: "shadow-lg"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_el_menu, {
        class: "w-100",
        mode: "horizontal",
        ellipsis: false,
        router: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [_hoisted_3, _hoisted_4]),
          _: 1
        }), _hoisted_5, _createVNode(_component_el_menu_item, {
          index: "/item"
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/monster"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }), _createVNode(_component_el_main, {
      class: "main-container container"
    }, {
      default: _withCtx(() => [_createVNode(_component_router_view)]),
      _: 1
    }), _createVNode(_component_el_backtop, {
      bottom: 100
    })]),
    _: 1
  });
}